/**
 * Opens the shared lightbox for wiki-rendered images. The Image renderer
 * (Objects/Text/Wiki/Render/Xhtml/Ifixit/Image.php) marks them
 * js-lightbox-image and carries the largest rendition as data-lightbox-src;
 * this binds the click side of that contract. Call it from every entry whose
 * page renders that markup: Answers, stories, wiki and device pages, the
 * wiki editor's preview, and the dashboards that inject post HTML. Binding
 * is idempotent, so entries can overlap. One delegated document listener
 * covers content injected after page load.
 */
declare global {
   interface Window {
      // The renderer's inline onclick opens its popup only while this is unset.
      lightboxImageClicksBound?: boolean;
   }
}

export function bindLightboxImageClicks() {
   if (window.lightboxImageClicksBound) {
      return;
   }
   window.lightboxImageClicksBound = true;
   document.addEventListener('click', async event => {
      const img = event.target instanceof Element && event.target.closest('img.js-lightbox-image');
      if (!img || !(img instanceof HTMLImageElement) || !img.dataset.lightboxSrc) {
         return;
      }
      const { openImageLightbox } = await import('Shared/ImageLightbox');
      openImageLightbox(img.dataset.lightboxSrc, img.currentSrc);
   });
}
